define.alias("shared/helpers/format-currency", "preview-grid/helpers/format-currency");